import React from "react";

function Copy() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 -960 960 960"
    >
      <path d="M175.478-56.694q-32.74 0-56.262-23.522t-23.522-56.262v-597.913h79.784v597.913h468.913v79.784H175.478zm139.218-139.784q-32.507 0-55.862-23.356-23.356-23.355-23.356-55.862v-549.826q0-32.74 23.356-56.262 23.355-23.522 55.862-23.522h429.826q32.74 0 56.262 23.522t23.522 56.262v549.826q0 32.507-23.522 55.862-23.522 23.356-56.262 23.356H314.696zm0-79.218h429.826v-549.826H314.696v549.826zm0 0v-549.826 549.826z"></path>
    </svg>
  );
}

export default Copy;
